/**
 * User-facing progress statuses. The `*_equivalent` variants mean the status
 * was not earned on this problem directly but on a linked duplicate (the same
 * question from another source) — UI renders them similar-but-distinct.
 */
export type UserProgressStatus =
  | 'solved'
  | 'attempted'
  | 'solved_equivalent'
  | 'attempted_equivalent'

/** True for a direct or duplicate-propagated solve. */
export function isSolvedStatus(status: string | null | undefined): boolean {
  return status === 'solved' || status === 'solved_equivalent'
}

/** True for an unfinished attempt, direct or propagated. */
export function isAttemptedStatus(status: string | null | undefined): boolean {
  return status === 'attempted' || status === 'attempted_equivalent'
}

/**
 * Collapse a status to its direct form for filtering/sorting/counting:
 * propagated solves group with solves, every attempted variant with attempted.
 */
export function canonicalStatus(
  status: string | null | undefined,
): 'solved' | 'attempted' | undefined {
  if (isSolvedStatus(status)) return 'solved'
  if (isAttemptedStatus(status)) return 'attempted'
  return undefined
}
